var __jsx = React.createElement;
import stl from "./TechnicalError.module.css";
import { useTranslation } from "@i18n";
import React from "react";
import { CDN_LINK } from "@globalConfig";
var TechnicalError = function TechnicalError(_ref) {
  var text = _ref.text,
    onClickHome = _ref.onClickHome,
    onClickMain = _ref.onClickMain;
  var _useTranslation = useTranslation(["web_sell_trade"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/tracking-details/technical-error.svg"
  }), /*#__PURE__*/React.createElement("strong", null, text), /*#__PURE__*/React.createElement("p", null, t("go_back_track_order_go", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("button", {
    className: stl.mainButton,
    onClick: onClickMain
  }, t("go_back_track_order", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("button", {
    className: stl.btn,
    onClick: onClickHome
  }, t("go_homepage", {
    ns: "web_common"
  }))));
};
export default TechnicalError;